import React from 'react';
import ReactDOM from 'react-dom';
import App from 'App';
import {
  initAmplitude,
  sendAmplitudeData,
  setAmplitudeVersion,
} from 'util/amplitude';

initAmplitude();
setAmplitudeVersion('1.3');
console.log('Starting Render');
const swPath = `${process.env.PUBLIC_URL}/firebase-messaging-sw.js`;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker
    .register(swPath)
    .then((registration) => {
      console.log('Service worker registered', registration.scope);
    })
    .catch((err) => {
      console.log('SW registration failed', err);
    });
  navigator.serviceWorker.onmessage = (event) => {
    const notificationUrl = event.data.notificationSoundUrl;
    try {
      let sound = new Audio(notificationUrl);
      sound.play();
      sendAmplitudeData('Bg Notification event', {
        payload: event,
        notificationUrl: notificationUrl,
      });
    } catch (err) {
      sendAmplitudeData('Bg Notification Error', {
        error: err,
      });
    }
  };
}

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
